import React from 'react'
import { useLocation } from 'react-router-dom';
import Sidebarlayout from '../../Layouts/Sidebarlayout';
import '../../Assets/Css/ViewEmployee.scss';
import { Link } from 'react-router-dom';


const ViewEmployee = () => {
    const location = useLocation();
    const data = location.state;
    console.log(data);
    return (
        <Sidebarlayout>
            <div className='viewEmployee-main'>
                <div className="page-title">
                    <h4>View Employee</h4>
                    <div className="edit-btn">
                        <button type="button" className="custom-btn">
                            <Link to='/employee/edit' style={{ textDecoration: "inherit", color: "inherit" }} state={data}>Edit</Link>
                        </button>
                    </div>

                </div>
            </div>
        </Sidebarlayout>
    )
}

export default ViewEmployee
